import React, { createContext, useContext, useEffect, useState } from 'react';
import { AuthContext } from './AuthContext';
import { featuresAPI } from '../services/api';

// Which optional modules (client_portal, gps_checkin) this installation has
// on. The server decides (FEATURES in its environment); the frontend only
// asks, once signed in. Everything is off until the answer arrives and if
// the request fails, so a module never shows by mistake.
const ALL_OFF = { client_portal: false, gps_checkin: false };

export const FeaturesContext = createContext({ features: ALL_OFF, loaded: false });

export const FeaturesProvider = ({ children }) => {
  const { user } = useContext(AuthContext);
  const [state, setState] = useState({ features: ALL_OFF, loaded: false });

  useEffect(() => {
    let cancelled = false;
    if (!user) {
      setState({ features: ALL_OFF, loaded: false });
      return undefined;
    }
    featuresAPI.get()
      .then((res) => { if (!cancelled) setState({ features: { ...ALL_OFF, ...res.data.features }, loaded: true }); })
      .catch(() => { if (!cancelled) setState({ features: ALL_OFF, loaded: true }); });
    return () => { cancelled = true; };
  }, [user]);

  return <FeaturesContext.Provider value={state}>{children}</FeaturesContext.Provider>;
};

// true only when the server said the module is on
export const useFeature = (name) => useContext(FeaturesContext).features[name] === true;

// Renders its children only while the module is on (menus, buttons, routes)
export const Feature = ({ name, children, fallback = null }) => (useFeature(name) ? children : fallback);
